<template>
    <article class="i-radio-tabs">
        <ul class="i-radio-tabs__list">
            <li
                v-for="(tab, name, i) in tabs"
                :key="i"
                class="i-radio-tabs__item">
                <input
                    class="visually-hidden"
                    type="radio"
                    :name="`filter-radio-${id}`"
                    :id="`radio-${id}-${name}`"
                    :value="tab"
                    v-model="value"
                    @change="$emit('tabsChanged', value, name)" />
                <label
                    :for="`radio-${id}-${name}`"
                    v-html="tab"></label>
            </li>
        </ul>
    </article>
</template>

<script>
    export default {
        name: 'RadioTabs',
        props: {
            tabs: {
                type: Array,
                default: []
            },
            id: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                value: null,
            }
        },
        beforeMount() {
            this.value = Object.values(this.tabs)[0]
            if (this.tabs.msfo || this.tabs.osbu) {
                const location = window.location.pathname.split('/').filter(Boolean)
                this.value = this.tabs[location[location.length - 1]]
            }
        }
    }
</script>